import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import { JobPostingDetail, JobPostingDetailData } from '../types';

interface UseAPIMutationInput {
  jobPostingId?: JobPostingDetail['id'];
  jobPostingFields?: Partial<JobPostingDetailData>;
}

const useUpdateVacancyMutation = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<JobPostingDetail, unknown>,
      AxiosError<unknown, unknown>,
      UseAPIMutationInput,
      unknown
    >,
    'mutationFn'
  >
) => {
  return useAPIMutation(async ({ jobPostingId, jobPostingFields }: UseAPIMutationInput, api) => {
    return api.patch(`/job-postings/${jobPostingId}/`, {
      ...jobPostingFields,
    });
  }, options);
};

export default useUpdateVacancyMutation;
